import { ApiClient } from './client.js'
import { ORDERS } from './resources.js'

const client = new ApiClient()

export default {
  retrieve (orderId) {
    return client.get(`${ORDERS}${orderId}/`)
  },

  list () {
    return client.get(`${ORDERS}`)
  },

  listAll () {
    return client.getAll(`${ORDERS}`)
  },

  create (data) {
    return client.post(`${ORDERS}`, data)
  },

  partialUpdate (orderId, data) {
    return client.patch(`${ORDERS}${orderId}/`, data)
  },

  finalize (orderId, data) {
    return client.post(`${ORDERS}${orderId}/finalize/`, data)
  }
}
